import { render } from "./UserModule.vue?vue&type=template&id=9fef1fd4&scoped=true"
import script from "./UserModule.vue?vue&type=script&lang=js"
export * from "./UserModule.vue?vue&type=script&lang=js"

import "./UserModule.vue?vue&type=style&index=0&id=9fef1fd4&lang=scss&scoped=true"
import "./UserModule.vue?vue&type=style&index=1&id=9fef1fd4&lang=scss"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fef1fd4"]])

export default __exports__